import React from 'react';

import { FieldArray } from 'formik';
import { ReactComponent as FieldArrayAddIcon } from 'assets/icons/field-array-add.svg';
import { ReactComponent as FieldArrayRemoveIcon } from 'assets/icons/field-array-remove.svg';
import { SectionLine } from '../components/SectionLine';
import { FormikPremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import { FieldArrayButton } from '../components/FieldArrayButton';
import TotalsSeparator from '../components/TotalsSeparator';
import TotalsLine from '../components/TotalsLine';
import TotalsText from '../components/TotalsText';
import { SectionContainer } from '../components/SectionContainer';
import { SectionBody } from '../components/SectionBody';
import SectionTitle from '../components/SectionTitle';
import ticketService from '../../../ticketService';

const LoadsList = ({ ticketFormBodyData }) => {
  const loads = ticketFormBodyData.values.order_data.loads_data.loads;
  return (
    <>
      <FieldArray
        name="order_data.loads_data.loads"
        render={(arrayHelpers) => (
          <>
            {loads.map((load, index) => (
              <SectionLine key={index}>
                <LoadForm
                  load={load}
                  index={index}
                  arrayHelpers={arrayHelpers}
                  ticketFormBodyData={ticketFormBodyData}
                />
              </SectionLine>
            ))}
          </>
        )}
      />
    </>
  );
};

const LoadForm = ({ key, load, index, arrayHelpers, ticketFormBodyData }) => {
  const { showErrors, isReadOnly } = ticketFormBodyData;
  return (
    <>
      <FormikPremiumInput
        type={'number'}
        isRequired={true}
        label={'Units'}
        showErrors={showErrors}
        name={`order_data.loads_data.loads.${index}.number_of_items`}
        width={'80px'}
        isDisabled={isReadOnly}
      />

      <FormikPremiumInput
        label="Type"
        showErrors={showErrors}
        name={`order_data.loads_data.loads.${index}.load_type`}
        type={'select'}
        isRequired={true}
        isDisabled={isReadOnly}
        availableOptions={[
          {
            value: 'eupallet',
            label: 'European pallet',
          },
          {
            value: 'americanpallet',
            label: 'American pallet',
          },
          {
            value: 'cage',
            label: 'Cage',
          },
          {
            value: 'envelope',
            label: 'Envelope',
          },
          {
            value: 'box',
            label: 'Box',
          },
          {
            value: 'suitcase',
            label: 'Suitcase',
          },
          {
            value: 'drum',
            label: 'Drum',
          },
          {
            value: 'aero',
            label: 'Aero Plate',
          },
          {
            value: 'rolls',
            label: 'Rolls (i.e. Fabric)',
          },
          {
            value: 'others',
            label: 'Others',
          },
        ]}
      />
      <FormikPremiumInput
        type={'number'}
        label={'Width'}
        units={'cm'}
        isDisabled={isReadOnly}
        showErrors={showErrors}
        name={`order_data.loads_data.loads.${index}.item_width`}
        width={'100px'}
      />
      <FormikPremiumInput
        type={'number'}
        label={'Length'}
        units={'cm'}
        isDisabled={isReadOnly}
        showErrors={showErrors}
        name={`order_data.loads_data.loads.${index}.item_length`}
        width={'100px'}
      />
      <FormikPremiumInput
        type={'number'}
        label={'Height'}
        units={'cm'}
        isDisabled={isReadOnly}
        showErrors={showErrors}
        name={`order_data.loads_data.loads.${index}.item_height`}
        width={'100px'}
      />
      {!isReadOnly && index === 0 && (
        <FieldArrayButton
          onClick={(e) => {
            arrayHelpers.push(ticketService.defaultValues.getDefaultLoad());
          }}
        >
          <FieldArrayAddIcon />
        </FieldArrayButton>
      )}
      {!isReadOnly && index > 0 && (
        <FieldArrayButton
          onClick={(e) => {
            return arrayHelpers.remove(index);
          }}
        >
          <FieldArrayRemoveIcon />
        </FieldArrayButton>
      )}
    </>
  );
};

const TotalLoads = ({ ticketFormBodyData }) => {
  const { showErrors, isReadOnly } = ticketFormBodyData;

  return (
    <>
      <TotalsSeparator>
        <TotalsLine />
        <TotalsText>Total</TotalsText>
        <TotalsLine />
      </TotalsSeparator>
      <SectionLine>
        <FormikPremiumInput
          label={'Weight'}
          isRequired={true}
          name="order_data.loads_data.totals.total_weight"
          showErrors={showErrors}
          type="number"
          units={'kg'}
          min={0}
          isDisabled={isReadOnly}
        />
        <FormikPremiumInput
          label={'Volume'}
          name="order_data.loads_data.totals.cubic_meters"
          showErrors={showErrors}
          isRequired={false}
          type="number"
          units={'m³'}
          min={0}
          isDisabled={isReadOnly}
        />
        <FormikPremiumInput
          label={'Linear meters'}
          name="order_data.loads_data.totals.linear_meters"
          showErrors={showErrors}
          isRequired={false}
          type="number"
          units={'m'}
          min={0}
          isDisabled={isReadOnly}
        />
      </SectionLine>
    </>
  );
};

export const LoadSection = ({ ticketFormBodyData }) => {
  return (
    <>
      <SectionContainer>
        <SectionTitle>Load</SectionTitle>
        <SectionBody>
          <LoadsList ticketFormBodyData={ticketFormBodyData} />
          <TotalLoads ticketFormBodyData={ticketFormBodyData} />
        </SectionBody>
      </SectionContainer>
    </>
  );
};
